import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { InstallationsFilterType } from '@store';

@Component({
  selector: 'app-installation-filter',
  templateUrl: './installation-filter.component.html',
  styleUrls: ['./installation-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InstallationFilterComponent {
  readonly installationsFilterType = InstallationsFilterType;

  @Input() activeFilter: InstallationsFilterType = InstallationsFilterType.All;
  @Input() installationsAmount;
  @Input() errorsAmount;
  @Input() offlineAmount;
  @Input() maintenanceAmount;
  @Input() remoteDiagnosticAmount;
  @Input() coldSystemAmount;
  @Input() workingAmount;

  @Output() filter: EventEmitter<InstallationsFilterType> = new EventEmitter<
    InstallationsFilterType
  >();

  filterInstallations(filter: InstallationsFilterType): void {
    this.activeFilter = filter;
    this.filter.emit(filter);
  }
}
